<template>
  <v-chip
    outlined
    small
    :color="updateByClient ? 'red' : 'green'"
  >
    {{ updateByClient ? "Самостійно" : "Tqm Systems" }}
  </v-chip>
</template>

<script>
export default {
  props: {
    updateByClient: {
      type: Boolean,
      required: true,
    },
  },
};
</script>